import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RequirePermission } from '@/components/state/RequirePermission'
import { VoiceFabProvider } from '@/features/tarefas/voz/VoiceFab'

// O botão de voz mora no layout para aparecer na lista e no quadro. A porta fica
// por fora dele: sem acesso, nem a configuração da voz é pedida.
export const Route = createFileRoute('/_app/app/tarefas')({
  component: () => (
    <RequirePermission permission="tarefas.view" pageTitle="Tarefas">
      <VoiceFabProvider>
        <Outlet />
      </VoiceFabProvider>
    </RequirePermission>
  ),
})
